import React from 'react';
import { Redirect } from 'react-router-dom';

function Home(props) {
  return (
    <Redirect to="/stats"/>
  );
}

export default Home;



// WEBPACK FOOTER //
// ./src/app/home.js